import * as React from 'react';
import * as ReactDOM from 'react-dom';
import intl from 'react-intl-universal';
import { destroyFns } from './Modal';
import ConfirmModal from './ConfirmModal';
import common from '../../../common/common';

export default function confirm(config = {}) {
    const div = document.createElement('div');
    document.body.appendChild(div);

    let currentConfig = {
        ...config,
        close,
        visible: true
    };

    function destroy(...args) {
        const unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        const triggerCancel = args.some(param => param && param.triggerCancel);
        if (config.onCancel && triggerCancel) {
            config.onCancel(...args);
        }
        for (let i = 0; i < destroyFns.length; i++) {
            const fn = destroyFns[i];
            if (fn === close) {
                destroyFns.splice(i, 1);
                break;
            }
        }
    }

    function render({ okText, cancelText,  ...props }) {
        setTimeout(() => {
            ReactDOM.render(
                <ConfirmModal
                    {...props}
                    showPendant={!common.isPhone()}
                    okText={okText || (props.showCancel ? intl.get('OK_TEXT') : intl.get('JUST_OK_TEXT'))}
                    cancelText={cancelText || intl.get('CANCEL_TEXT')}
                />,
                div,
            );
        });
    }

    function close(...args) {
        currentConfig = {
            ...currentConfig,
            visible: false,
            afterClose: destroy.bind(this, ...args),
        };
        render(currentConfig);
    }

    function update(configUpdate) {
        if (typeof configUpdate === 'function') {
            currentConfig = configUpdate(currentConfig);
        } else {
            currentConfig = {
                ...currentConfig,
                ...configUpdate,
            };
        }
        render(currentConfig);
    }

    render(currentConfig);

    destroyFns.push(close);

    return {
        destroy: close,
        update,
    };
}

export function withInfo(props) {
    return {
        type: 'info',
        showCancel: false,
        ...props,
    };
}

export function withConfirm(props) {
    return {
        type: 'confirm',
        showCancel: true,
        ...props,
    };
}